import { render, staticRenderFns } from "./ExtensionDisplay.vue?vue&type=template&id=1f7e4560&"
import script from "./ExtensionDisplay.vue?vue&type=script&lang=js&"
export * from "./ExtensionDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports